import styled from 'styled-components'

const Container = styled.div`
  .MuiAccordion-rounded {
    width: 100%;
  }
  .inner-section {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(198px, 1fr));
    width: 100%;
    margin-bottom: 20px;
    padding-right: 30px;
    p {
      font-size: 16px;
      color: #000000;
    }
    span {
      color: #5c666b;
    }
    @media (max-width: 650px) {
        grid-template-columns: 1fr 1fr;
    }
  }

  .overflow{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
const UperContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(198px, 1fr));
  width: 100%;
  .pallete-image {
    img {
      max-width: 120px;
      width: 100%;
    }
  }  
  p {
    font-size: 16px;
    color: #000000;
  }
  span {
    color: #5c666b;
  }
  @media (max-width: 650px) {
    grid-template-columns: 1fr 1fr;
  }
`;
const MyBidsMobileViewWrapper = styled.div`
  .mobile-bid-accordion {
    margin-bottom: 10px;
    box-shadow: 0px 2px 10px 0px #00000029;
  }

  .accordion-header {
    display: grid;
    grid-template-columns: 2fr 0.1fr;
    justify-content: space-between;
    align-items: center;
    padding: 10px 10px 0px 15px;
    cursor: pointer;
  }

  .accordion-header-left {
    display: grid;
    grid-template-columns: 0.68fr 0.8fr;
  }

  .accordion-header-right {
    display: flex;
    align-items: center;
  }

  .accordion-content {
    padding: 10px 0px 15px 15px;
    display: flex;
    flex-direction: column;
  }

  .accordion-column {
    display: flex;
    flex-direction: column;
  }

  .bid-info-header {
    display: grid;
    grid-template-columns: 0.6fr 0.8fr;
  }

  .bid-info {
    margin-bottom: 7px;
    p{
      margin: 3px 0 0 0px;
      font-size: 15px;
      font-family: 'latobold';
    }
    h6{
      font-size: 13px;
      font-family: 'latoregular';
    }
  }

  .accordion-buttons {
    display: flex;
    gap: 10px;
    margin-top: 10px;
    justify-content: center;
  }
`;
export { Container, UperContainer, MyBidsMobileViewWrapper };